import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useEditGsuiteAccountMutation } from "@/redux/services/gsuitesApi"
import { setToast } from "@/redux/toastSlice"
import type { EditGsuiteAccountPayload } from "@/types/entities/gsuite-account"

export const useEditGsuiteAccount = () => {
  const dispatch = useAppDispatch()
  const [editGsuiteAccount, response] = useEditGsuiteAccountMutation()

  const handleEditGsuiteAccounts = async ({
    id,
    body,
  }: {
    id: string
    body: EditGsuiteAccountPayload
  }) => {
    try {
      const response = await editGsuiteAccount({ body, id }).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success edit account",
          }),
        )
      }
      return response
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { editGsuiteAccount: handleEditGsuiteAccounts, response }
}
